import React, { useState } from 'react';
import { Container, Box, Typography, Button, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {
    WorkOutline as WorkOutlineIcon,
    FavoriteOutlined as FavoriteOutlinedIcon,
    SchoolOutlined as SchoolOutlinedIcon,
    SelfImprovementOutlined as SelfImprovementOutlinedIcon,
    ArrowForward as ArrowForwardIcon
} from '@mui/icons-material';
import WorkAreaItem from '../WorkAreaItem';
import EmailCollectionModal from '../EmailCollectionModal';
import { saveEmailSignup } from '../../utils/api';

const WorkAreasSection = ({ FadeInSection }) => {
    const navigate = useNavigate();
    const [emailModalOpen, setEmailModalOpen] = useState(false);
    const [selectedArea, setSelectedArea] = useState(null);

    const handleEmailCollection = async (data) => {
        try {
            // Save email to backend with area name as source
            const source = `work_area_${selectedArea.toLowerCase().replace(/\s+/g, '_')}`;
            await saveEmailSignup(data.name, data.email, source, '10%');

            alert(`Dziękujemy! Zapisaliśmy Cię na powiadomienia o obszarze "${selectedArea}".`);
        } catch (error) {
            console.error('Error collecting email:', error);
            throw error;
        }
    };

    const handleInactiveAreaClick = (area) => {
        setSelectedArea(area);
        setEmailModalOpen(true);
    };

    const workAreas = [
        {
            icon: WorkOutlineIcon,
            label: 'Praca',
            description: 'Zmiana kariery, konflikty w pracy, wypalenie zawodowe i rozwój profesjonalny.',
            active: true
        },
        {
            icon: FavoriteOutlinedIcon,
            label: 'Relacje',
            description: 'Budowanie zdrowych relacji, komunikacja i rozwiązywanie konfliktów.',
            active: false,
            onClick: () => handleInactiveAreaClick('Relacje')
        },
        {
            icon: SelfImprovementOutlinedIcon,
            label: 'Zmiana nawyków',
            description: 'Budowanie nowych nawyków i pozbycie się tych, które Ci nie służą.',
            active: false,
            onClick: () => handleInactiveAreaClick('Zmiana nawyków')
        },
        {
            icon: SchoolOutlinedIcon,
            label: 'Rozwój',
            description: 'Rozwój osobisty, budowanie pewności siebie i osiąganie celów życiowych.',
            active: false,
            onClick: () => handleInactiveAreaClick('Rozwój')
        }
    ];

    const workCTA = (
        <Button
            variant="contained"
            size="large"
            endIcon={<ArrowForwardIcon />}
            onClick={() => navigate('/zmiana-pracy')}
            sx={{
                bgcolor: 'primary.main',
                color: 'white',
                px: 4,
                py: 1.5,
                fontSize: '1.1rem',
                fontWeight: 'bold',
                borderRadius: 3,
                textTransform: 'none',
                boxShadow: '0 4px 15px rgba(199, 154, 95, 0.3)',
                '&:hover': {
                    bgcolor: 'primary.dark',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 6px 20px rgba(199, 154, 95, 0.4)'
                },
                transition: 'all 0.3s ease'
            }}
        >
            Rozpocznij pracę nad karierą
        </Button>
    );

    return (
        <Box id="work-areas" sx={{ py: 12, bgcolor: 'grey.50' }}>
            <Container maxWidth="lg">
                <FadeInSection>
                    <Typography
                        variant="h3"
                        sx={{
                            textAlign: 'center',
                            fontWeight: 'bold',
                            color: 'grey.800',
                            mb: 3
                        }}
                    >
                        Obszary pracy aplikacji
                    </Typography>
                    <Typography
                        variant="h5"
                        sx={{
                            textAlign: 'center',
                            color: 'grey.700',
                            mb: 2,
                            maxWidth: '700px',
                            mx: 'auto',
                            fontWeight: 'medium'
                        }}
                    >
                        Zbuduj swoją preferowaną przyszłość w najważniejszych dla Ciebie obszarach.
                    </Typography>
                    <Typography
                        variant="h6"
                        sx={{
                            textAlign: 'center',
                            color: 'grey.600',
                            mb: 8,
                            maxWidth: '800px',
                            mx: 'auto'
                        }}
                    >
                        Aplikacja Find solution jest elastyczna. Umożliwia Ci wybór konkretnego obszaru pracy i dostosowuje narzędzia do Twoich potrzeb.
                    </Typography>
                </FadeInSection>

                <Grid container spacing={4}>
                    {workAreas.map((area, index) => (
                        <Grid item xs={12} sm={6} md={6} key={index}>
                            <WorkAreaItem
                                icon={area.icon}
                                label={area.label}
                                description={area.description}
                                isActive={area.active}
                                isEven={index % 2 === 0}
                                delay={index * 0.1}
                                FadeInSection={FadeInSection}
                                ctaButton={area.active ? workCTA : null}
                                onClick={area.onClick}
                            />
                        </Grid>
                    ))}
                </Grid>

                <EmailCollectionModal
                    open={emailModalOpen}
                    onClose={() => setEmailModalOpen(false)}
                    onSubmit={handleEmailCollection}
                    title="Jeszcze chwila!"
                    description={`Aktywnie pracujemy nad obszarem "${selectedArea}". Zostaw nam swój e-mail, a damy Ci znać gdy tylko będzie gotowy.`}
                />
            </Container>
        </Box>
    );
};

export default WorkAreasSection;
